export default "__VITE_ASSET__CQmNlGxG__"